<template>
  <div class="dataDisplay">
    <!-- 数据展示 -->
    <div class="list">
      <!-- 购买数据 -->
      <div class="item purchaseData">
        <div class="name">
          {{ $t('message.purchaseData') }}
          <img src="@/assets/icon/表格.svg" alt="" class="fr" @click="orderDetail">
        </div>
        <div class="content">
          <!--购买次数  -->
          <div class="item-num">
            {{ $t('message.purchaseFrequency') }}
            <div class="num">{{ detail.orderData.buy_count }}</div>
          </div>
          <!--总购买量  -->
          <div class="item-num">
            {{ $t('message.TotalPurchaseVolume') }}
            <div class="num">{{ detail.orderData.buy_num }}</div>
          </div>
          <!--总采购额  -->
          <div class="item-num">
            {{ $t('message.TotalPurchaseAmount') }}
            <div class="num">￥{{ detail.orderData.buy_amount }}</div>
          </div>
          <div class="border"></div>
          <!--商品以外产生费用  -->
          <div class="item-num">
            {{ $t('message.ExpensesIncurredOutsideProduct') }}
            <div class="num">￥{{ detail.orderData.buy_cost_amount }}</div>
          </div>
        </div>
      </div>
      <!-- 购买数据  -->
      <div class="item purchaseData2">
        <div class="name">
          {{ $t('message.purchaseData') }}
          <!-- <img src="@/assets/icon/折线图.svg" alt="" class="fr"> -->
        </div>
        <div class="content">
          <!--平均采购价  -->
          <div class="item-num">
            {{ $t('message.AveragePurchasePrice') }}
            <div class="num">￥{{ detail.orderData.buy_price_avg }}</div>
          </div>
          <!--最低采购价  -->
          <div class="item-num">
            {{ $t('message.MinimumPurchasePrice') }}
            <div class="num green-num">￥{{ detail.orderData.buy_price_min }}</div>
          </div>
          <!--最高采购价  -->
          <div class="item-num">
            {{ $t('message.maxPurchasePrice') }}
            <div class="num red-num">￥{{ detail.orderData.buy_price_max }}</div>
          </div>
        </div>
      </div>
      <!-- 出货数据 -->
      <div class="item ShipmentData">
        <div class="name">
          {{ $t('message.ShipmentData') }}
          <!-- 出货记录 -->
          <el-button type="text" @click="porderDeliveryList" class="fr">{{ $t('message.shipmentRecord') }}</el-button>
        </div>
        <div class="content">
          <!--出货次数  -->
          <div class="item-num">
            {{ $t('message.NumberShipments') }}
            <div class="num">{{ detail.orderData.send_count }}</div>
          </div>
          <!--出货数量  -->
          <div class="item-num">
            {{ $t('message.ShipmentQuantity') }}
            <div class="num ">{{ detail.orderData.send_num }}</div>
          </div>
        </div>
      </div>
      <!-- 常用出货物流 -->
      <div class="item  CommonShippingLogistics">
        <div class="name">
          {{ $t('message.CommonShippingLogistics') }}
          <img src="@/assets/icon/帮助.svg" alt="">
        </div>
        <div class="content">
          <div class="template">
            <div class="row" v-for="(item, index) in detail.orderData.send_logistics_list" :key="index"
              v-show="index < 3">
              <!-- 物流 -->
              <div class="logistics">
                <img src="@/assets/icon/1.svg" alt="" v-if="index == 0">
                <img src="@/assets/icon/2.svg" alt="" v-if="index == 1">
                <img src="@/assets/icon/3.svg" alt="" v-if="index == 2">
                {{ item.logistics_name }}
              </div>
              <!-- 次数 -->
              <div class="frequency">{{ item.count }}次</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 第二行   -->
    <div class="list list2">
      <!-- 商品采购纳期  -->
      <div class="item purchaseData2">
        <div class="name">
          {{ $t('message.DeliverTimCommodityProcurement') }}
          <img src="@/assets/icon/帮助.svg" alt="">
          <!-- <img src="@/assets/icon/折线图.svg" alt="" class="fr"> -->
        </div>
        <div class="content">
          <div class="item-num  ">
            {{ $t('message.TheSlowest') }}
            <div class="num green-num">{{ detail.orderData.purchase_days.min }}日</div>
          </div>
          <!--最慢  -->
          <div class="item-num">
            {{ $t('message.Fastest') }}
            <div class="num  red-num">{{ detail.orderData.purchase_days.max }}日</div>
          </div>
          <div class="border"></div>
          <!--平均纳期  -->
          <div class="item-num">
            {{ $t('message.AverageDeliveryTime') }}
            <div class="num">{{ detail.orderData.purchase_days.avg }}天</div>
          </div>
        </div>
      </div>
      <!-- 处理纳期  -->
      <div class="item purchaseData2">
        <div class="name">
          {{ $t('message.ProcessingDeliveryTime') }}
          <img src="@/assets/icon/帮助.svg" alt="">
          <!-- <img src="@/assets/icon/折线图.svg" alt="" class="fr"> -->
        </div>
        <div class="content">

          <div class="item-num  ">
            {{ $t('message.TheSlowest') }}
            <div class="num green-num">{{ detail.orderData.wms_deal_days.min }}日</div>
          </div>
          <!--最慢  -->
          <div class="item-num">
            {{ $t('message.Fastest') }}
            <div class="num  red-num">{{ detail.orderData.wms_deal_days.max }}日</div>
          </div>
          <div class="border"></div>
          <!--平均纳期  -->
          <div class="item-num">
            {{ $t('message.AverageDeliveryTime') }}
            <div class="num">{{ detail.orderData.wms_deal_days.avg }}天</div>
          </div>
        </div>
      </div>
      <!-- 出货纳期  -->
      <div class="item DeliveryTime">
        <div class="name">
          {{ $t('message.DeliveryTime') }}

          <img src="@/assets/icon/帮助.svg" alt="">
          <!-- <img src="@/assets/icon/折线图.svg" alt="" class="fr"> -->
        </div>
        <div class="content">

          <div class="item-num  ">
            {{ $t('message.TheSlowest') }}
            <div class="num green-num">{{ detail.orderData.wms_delivery_days.min }}日</div>
          </div>
          <!--最慢  -->
          <div class="item-num">
            {{ $t('message.Fastest') }}
            <div class="num  red-num">{{ detail.orderData.wms_delivery_days.max }}日</div>
          </div>
          <div class="border"></div>
          <!--平均纳期  -->
          <div class="item-num">
            {{ $t('message.AverageDeliveryTime') }}
            <div class="num">{{ detail.orderData.wms_delivery_days.avg }}天</div>
          </div>
        </div>
      </div>
      <!-- 不良数据  -->
      <div class="item badData">
        <div class="name">
          {{ $t('message.badData') }}
          <img src="@/assets/icon/表格.svg" alt="" class="fr" @click="problemListDetail">
        </div>
        <div class="content">
          <!--不良次数  -->
          <div class="item-num">
            {{ $t('message.NumberDefects') }}
            <div class="num">{{ detail.orderData.bad_count }}次</div>
          </div>
          <!--不良数量  -->
          <div class="item-num">
            {{ $t('message.NumberOfDefects') }}
            <div class="num">{{ detail.orderData.bad_num }}个</div>
          </div>
          <div class="border"></div>
          <img src="@/assets/icon/不良率.svg" alt="" style="width: 46px;margin-right: 12px;">
          <!--不良率  -->
          <div class="item-num">
            {{ $t('message.defectRate') }}
            <div class="num ">
              {{ detail.orderData.bad_rate }} %
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 不良列表 -->
    <badData ref="badData" />
    <!--购买数据  -->
    <purchaseData ref="purchaseData" />
    <!-- 出货记录 -->
    <shipmentData ref="shipmentData" />
  </div>
</template>
<script>
import badData from './dataDisplay/badData'
import purchaseData from './dataDisplay/purchaseData'
import shipmentData from './dataDisplay/shipmentData'
export default {
  components: {
    badData,
    purchaseData,
    shipmentData
  },
  props: {
    detail: { type: Object }
  },
  data() {
    return {

    };
  },
  methods: {
    // 不良人列表
    problemListDetail() {
      let skuCodes = []
      this.detail.client_product_link.forEach(item => {
        skuCodes.push(item.item_sku.sku_code)
      })
      this.$refs.badData.problemListDetail(skuCodes, this.detail.user_id)
    },
    // 订单单番明细
    orderDetail() {
      this.$refs.purchaseData.orderDetail(this.detail.orderList)
    },
    // 出货记录
    porderDeliveryList() {
      console.log(this.detail);
      let skuCodes = []
      this.detail.client_product_link.forEach(item => {
        skuCodes.push(item.sku_code)
      })
      this.$refs.shipmentData.porderDeliveryList(skuCodes, this.detail.user_id)
    },
  }
}
</script>
<style lang='scss' scoped>
.dataDisplay {
  margin-top: 12px;

  .list {
    display: flex;

    .purchaseData {
      flex: 2;
    }

    .purchaseData2 {
      flex: 1.5;
    }

    .ShipmentData,
    .CommonShippingLogistics {
      flex: 1;
    }

    .badData {
      flex: 1.8;
    }

    .item {
      padding: 20px 20px 34px;
      background: #F7F8FA;
      border-radius: 10px;
      margin-right: 12px;

      &:nth-last-child(1) {
        margin-right: 0;
      }

      .name {
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        margin-bottom: 20px;

        img {
          width: 20px;
          vertical-align: middle;
          cursor: pointer;
        }

        .el-button {
          line-height: 20px;
          padding: 0;
        }
      }

      .content {
        height: 63px;
        display: flex;

        .item-num {
          margin-right: 46px;

          &:nth-last-child(1) {
            margin-right: 0;
          }

          .num {
            margin-top: 17px;
            font-weight: bold;
            font-size: 24px;
            color: #333333;
            line-height: 24px;
          }

          .red-num {
            color: #DB3030;

          }

          .green-num {
            color: #4FB06F;
          }
        }

        .border {
          width: 1px;
          background-color: #dedede;
          margin-right: 46px;
        }

        .template {
          width: 100%;
          font-size: 16px;
          color: #333333;

          .row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 8px;

            .logistics {


              img {
                width: 20px;
                margin-right: 20px;
                vertical-align: middle;
              }
            }
          }
        }
      }
    }
  }

  .list2 {
    margin-top: 12px;

    .pic {
      width: 264px;
    }

    .customsClearanceInformation {
      width: 236px;
    }

    .productFile {
      flex: 1;
    }

    .content {
      height: 54px !important;

      .num {
        margin-top: 10px !important;
      }


    }
  }
}
</style>